import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    portfolio: {
      dialog: false,
      data: {
        type: "",
        img: "",
        text: {
          title: "",
          description: "",
          article: ""
        }
      }
    },
    gallery: {
      dialog: false,
      selected: 0,
      data: {
        title: '',
        link: '',
        description: ''
      }
    }
  },
  mutations: {
    SET_PORTFOLIO_DIALOG (state, data) {
      state.portfolio.dialog = data
    },
    SET_PORTFOLIO_DATA (state, data) {
      state.portfolio.data = data
    },

    SET_GALLERY_DIALOG (state, data) {
      state.gallery.dialog = data
    },
    SET_GALLERY_DATA (state, data) {
      state.gallery.data = data
    },
    SET_GALLERY_SELECTED (state, data) {
      state.gallery.selected = data
    }
  },
  actions: {
    openDial(context, data) {
      context.commit('SET_PORTFOLIO_DATA', data)
      context.commit('SET_PORTFOLIO_DIALOG', true)
    },
    openGallery(context, data) {
      context.commit('SET_GALLERY_SELECTED', data)
      context.commit('SET_GALLERY_DIALOG', true)
    }
  },
  getters: {
    portfolioDialog: (state) => { return state.portfolio.dialog },
    portfolioData: (state) => { return state.portfolio.data },

    galleryDialog: (state) => { return state.gallery.dialog },
    galleryData: (state) => { return state.gallery.data },
    gallerySelected: (state) => { return state.gallery.selected },
  }
});
